import { RouteConfig } from "vue-router";
import { REmployerServicesExtensionBrowse } from "@/pages/Layout/views/Employer/views/ServicesExtension/Browse/REmployerServicesExtensionBrowse";
import { REmployerServicesExtensionTemplate } from "@/pages/Layout/views/Employer/views/ServicesExtension/Template/REmployerServicesExtensionTemplate";

export const REmployerServicesExtension: RouteConfig = {
  path: "services/extension",
  name: "EmployerServicesExtension",
  component: () =>
    import(
      /* webpackChunkName: "employer-services-extension" */
      "./VEmployerServicesExtension.vue"
    ),
  meta: {
    hide: true,
    version: 2,
  },
  children: [REmployerServicesExtensionBrowse, REmployerServicesExtensionTemplate],
};
